import { get, post, put } from "../lib"
export interface UserPreferenceRequest {
    id?: number
    name:string
    val :string
}

export interface UserPreferenceResponse {
    id: number
    name:string
    val:string
    user: {id: number, name: string}
}

export const createUserPreference = async ( name: string, val: string) => {
    return  post<UserPreferenceRequest, UserPreferenceResponse>({
        path: '/api/v1/userPreference',
        body: {name, val}
    })
}

export const updateUserPreference = async (id: number, val: string) => {
    return  put<{val: string, id: number}, UserPreferenceResponse>({
        path: `/api/v1/userPreference/${id}`,
        body: {val, id}
    })
}

export const getAllUserPreference = async () => {
    return  get<Array<UserPreferenceResponse>>({
        path: '/api/v1/userPreference'
    })
}